import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import * as l18n from './assets/languages/zh.json'
import surveyRoutes from './addons/Survey/router.js'

Vue.use(Router)

// 解决 Vue Router 3.x 相同路由跳转报错的问题 (NavigationDuplicated)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  mode: 'history',
  base: '/web/',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      alias: '/home',
      meta: {
        title: '首页',
        l18ntitle: 'home',
        keepAlive: true,
        showAllNav: true,
        all: true
      }
    },
    {
      path: '/custom',
      name: 'custom',
      component: () => import('./views/Custom.vue'),
      meta: {
        headHide: true,
        footHide: true,
        showAllNav: true,
        title: '三利达',
        l18ntitle: 'custom',
      }
    },
    {
      path: '/register',
      name: 'register',
      component: () => import(/* webpackChunkName: "login" */ './views/Register.vue'),
      meta: {
        headHide: true,
        footHide: true,
        title: '注册',
        l18ntitle: 'register',
      }
    },
    {
      path: '/author',
      name: 'author',
      component: () => import(/* webpackChunkName: "login" */ './views/author.vue'),
      meta: {
        headHide: true,
        footHide: true,
        title: '授权',
        l18ntitle: 'authorization',
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
      meta: {
        headHide: true,
        footHide: true,
        title: '登录',
        l18ntitle: 'login'
      }
    },
    {
      path: '/search',
      name: 'search',
      component: () => import(/* webpackChunkName: "product" */ './views/SearchResult.vue'),
      meta: {
        title: '搜索结果',
        l18ntitle: 'searchResult',
        keepAlive: false,
        showAllNav: true
      }
    },
    {
      path: '/detail/:goodsId/:invite?',
      name: 'detail',
      component: () => import(/* webpackChunkName: "product" */ './views/ProductDetail.vue'),
      meta: {
        title: '商品详情',
        l18ntitle: 'detail',
        keepAlive: true
      }
    },
    {
      path: '/buySuccess',
      name: 'buySuccess',
      component: () => import(/* webpackChunkName: "product" */ './views/BuySuccess.vue'),
      meta: {
        title: '成功加入购物车',
        l18ntitle: 'addedToCartSuccessfully'
      }
    },
    {
      path: '/paySuccess',
      name: 'paySuccess',
      component: () => import(/* webpackChunkName: "product" */ './views/PaySuccess.vue'),
      meta: {
        title: '支付成功',
        l18ntitle: 'paySucess'
      }
    },
    {
      path: '/cart',
      name: 'cart',
      component: () => import(/* webpackChunkName: "cart" */ './views/MyCart.vue'),
      meta: {
        title: '我的购物车',
        l18ntitle: 'myCart',
        headHide: true,
      }
    },
    {
      path: '/ywhz',
      name: 'ywhz',
      component: () => import(/* webpackChunkName: "cart" */ './views/ywhz/index.vue'),
      meta: {
        title: '业务合作',
        l18ntitle: 'cooperation',
        showAllNav: false
      }
    },
    {
      path: '/article',
      name: 'article',
      redirect: '/article/index',
      component: () => import(/* webpackChunkName: "cart" */ './views/article/index.vue'),
      meta: {
        title: '新闻中心',
        l18ntitle: 'news'
      },
      children: [
        {
          path: 'index',
          name: 'articleIndex',
          component: () => import(/* webpackChunkName: "center" */ './views/article/list.vue'),
          meta: {
            title: '',
            keepAlive: false,
            showAllNav: false
          },
        },
        {
          path: 'detail',
          name: 'articledetail',
          component: () => import(/* webpackChunkName: "center" */ './views/article/detail.vue'),
          meta: {
            title: '',
            keepAlive: false,
            showAllNav: false
          },
        },
      ]
    },



    {
      path: '/video',
      name: "video",
      component: () =>  import('./views/video/index.vue'),
      meta: {
        title: '视频',
        l18ntitle: 'video',
        showAllNav: true
      },
    },

    {
      path: '/videodetail/:videoId',
      name: 'videodetail',
      component: () =>  import('./views/video/detail.vue'),
      meta: {
        title: '视频',
        l18ntitle: 'video',
        showAllNav: false
      },
    },

    {
      path: '/videoclassify',
      name: 'videoclassify',
      component: () =>  import('./views/video/classify.vue'),
      meta: {
        title: '视频分类',
        l18ntitle: 'video',
        showAllNav: true
      },
    },



    {
      path: '/arrows',
      name: 'arrows',
      redirect: '/arrows/index',
      component: () => import('./views/arrows/index.vue'),
      meta: {
        title: '射箭场馆',
        l18ntitle: 'arrow',
        showAllNav: false
      },
      children: [
        {
          path: 'index',
          name: 'Index',
          component: () => import('./views/arrows/list.vue'),
          meta: {
            title: '',
            keepAlive: false,
            showAllNav: false
          },
        }
      ]
    },

    {
      path: '/arrowsapply',
      name: 'arrowsapply',
      component: () => import(/* webpackChunkName: "center" */ './views/arrows/apply.vue'),
      meta: {
        title: '射箭场馆',
        l18ntitle: 'arrow',
      },
    },

    
    {
      path: '/arrowsdetail',
      name: 'arrowsdetail',
      component: () => import(/* webpackChunkName: "center" */ './views/arrows/detail.vue'),
      meta: {
        title: '射箭场馆',
        l18ntitle: 'arrow',


      },
    },
    {
      path: '/order',
      name: 'order',
      component: () => import(/* webpackChunkName: "cart" */ './views/Order.vue'),
      meta: {
        headHide: true,
        l18ntitle: 'information'
      }
    },
    {
      path: '/center',
      name: 'center',
      component: () => import(/* webpackChunkName: "center" */ './views/Center/Index.vue'),
      redirect: { name: 'User' },
      meta: {
        footShow: true
      },
      children: [
        {
          path: 'user',
          name: 'User',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/User.vue'),
          meta: {
            title: '我的个人中心',
            l18ntitle: 'myCenter',
            keepAlive: false
          },
        },
        
        {
          path: 'favourite',
          name: 'favourite',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/Favourite.vue'),
          meta: {
            title: l18n.collection, // 我的收藏
            l18ntitle: 'collection'
          },
        },

        {
          path: 'arrows',
          name: 'arrows',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/Arrow.vue'),
          meta: {
            title: '箭馆',
            l18ntitle: 'arrow'
          },
        },
        {
          path: 'footmark',
          name: 'footmark',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/FootMark.vue'),
          meta: {
            title: '我的足迹',
            l18ntitle: 'footprint'
          },
        },
        {
          path: 'balance',
          name: 'balance',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/Balance.vue'),
          meta: {
            title: '我的余额',
            l18ntitle: 'balance'
          },
        },
        {
          path: 'recharge',
          name: 'recharge',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/Recharge.vue'),
          meta: {
            title: '余额充值',
            l18ntitle: 'balance'
          },
        },

        {
          path: 'withdrawal',
          name: 'withdrawal',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/withdrawal.vue'),
          meta: {
            title: '分销中心',
            l18ntitle: 'balance'
          },
        },

        {
          path: 'distribution',
          name: 'distribution',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/distributionMe.vue'),
          meta: {
            title: '分销中心',
            l18ntitle: 'balance'
          },
        },


        {
          path: 'distributionClient',
          name: 'distributionClient',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/distributionClient.vue'),
          meta: {
            title: '分销中心',
            l18ntitle: 'balance'
          },
        },
        {
          path: 'channel',
          name: 'channel',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/channelMe.vue'),
          meta: {
            title: '渠道中心',
            l18ntitle: 'balance'
          },
        },

        {
          path: 'channelApply',
          name: 'channelApply',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/channel/apply.vue'),
          meta: {
            title: '渠道中心',
            l18ntitle: 'balance'
          },
        },
        {
          path: 'staff',
          name: 'staff',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/channel/staff.vue'),
          meta: {
            title: '渠道中心',
            l18ntitle: 'balance'
          },
        },
        {
          path: 'goods',
          name: 'goods',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/channel/goods.vue'),
          meta: {
            title: '渠道中心',
            l18ntitle: 'balance'
          },
        },
        {
          path: 'staffwithdrawal',
          name: 'staffwithdrawal',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/channel/staffwithdrawal.vue'),
          meta: {
            title: '渠道中心',
            l18ntitle: 'balance'
          },
        },
        {
          path: 'staffadd',
          name: 'staffadd',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/channel/staffadd.vue'),
          meta: {
            title: '渠道中心',
            l18ntitle: 'balance'
          },
        },
        {
          path: 'staffshare',
          name: 'staffshare',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/channel/staffshare.vue'),
          meta: {
            title: '渠道中心',
            l18ntitle: 'balance'
          },
        },
        {
          path: 'stafforder',
          name: 'stafforder',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/channel/stafforder.vue'),
          meta: {
            title: '员工订单',
            l18ntitle: 'balance'
          },
        },

        {
          path: 'withdrawCash',
          name: 'withdrawCash',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/withdrawCash.vue'),
          meta: {
            title: '申请提现',
            l18ntitle: 'balance'
          },
        },

        {
          path: 'bank',
          name: 'bank',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/bank.vue'),
          meta: {
            title: '申请提现',
            l18ntitle: 'balance'
          },
        },

        {
          path: 'ali',
          name: 'ali',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/ali.vue'),
          meta: {
            title: '支付宝管理',
            l18ntitle: 'balance'
          },
        },

        {
          path: 'channelclient',
          name: 'channelclient',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/channelClient.vue'),
          meta: {
            title: '渠道中心员工',
            l18ntitle: 'balance'
          },
        },
        
        {
          path: 'myOrder',
          name: 'myOrder',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/MyOrder.vue'),
          meta: {
            title: '我的订单',
            l18ntitle: 'myOrder'
            
          },
        },
        {
          path: 'orderDetail/:order_id',
          name: 'orderDetail',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/OrderDetail.vue'),
          meta: {
            title: '订单详情',
            l18ntitle: 'myOrder'
          }
        },
        {
          path: 'userInfo',
          name: 'userInfo',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/UserInfo.vue'),
          meta: {
            title: '资料设置',
            l18ntitle: 'setting'
          }
        },
        {
          path: 'safeCenter',
          name: 'safeCenter',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/SafeCenter.vue'),
          meta: {
            title: '安全中心',
            l18ntitle: 'securityCenter'
          }
        },
        {
          path: 'address',
          name: 'address',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/Address.vue'),
          meta: {
            title: '收货地址',
            l18ntitle: 'shippingAddress'
          }
        },
        {
          path: 'point',
          name: 'point',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/Point.vue'),
          meta: {
            title: '我的X币',
            l18ntitle: 'integral'
          }
        },
        {
          path: 'coupon',
          name: 'coupon',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/Coupon.vue'),
          meta: {
            title: '我的优惠券',
            l18ntitle: 'coupon'
          }
        },
				{
				  path: 'mail',
				  name: 'coupon',
				  component: () => import(/* webpackChunkName: "center" */ './views/Center/Mail.vue'),
				  meta: {
				    title: '消息详情',
				    l18ntitle: 'coupon'
				  }
				},
        {
          path: 'receipt',
          name: 'receipt',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/Receipt.vue'),
          meta: {
            title: '我的发票',
            l18ntitle: 'invoic'
          }
        },
        {
          path: 'videoorder',
          name: 'videoorder',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/videoorder.vue'),
          meta: {
            title: '视频订单',
            l18ntitle: 'videoorder'
          }
        },
        {
          path: 'refund',
          name: 'refund',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/Refund/Index.vue'),
          meta: {
            title: '申请退换货',
            l18ntitle: 'applyForAfterSales'
          },
        },
        {
          path: 'refundDetail/:aftersales_id',
          name: 'refundDetail',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/Refund/RefundDetail.vue'),
          meta: {
            title: '退换货详情',
            l18ntitle: 'detail'
          }
        },
        {
          path: 'refundApply/:order_id',
          name: 'refundApply',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/Refund/RefundApply.vue'),
          meta: {
            title: '退换货申请',
            l18ntitle: 'applyForAfterSales'
          }
        },
        {
          path: 'evaluate',
          name: 'evaluate',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/Evaluate.vue'),
          meta: {
            title: '评价订单',
            l18ntitle: 'evaluate'
          }
        }
      ]
    },
    {
      path: '/help',
      name: 'help',
      component: () => import(/* webpackChunkName: "center" */ './views/Help/Index.vue'),
      meta: {
        footShow: true
      }
    },
    {
      path: '/helpdetail',
      name: 'helpdetail',
      component: () => import(/* webpackChunkName: "center" */ './views/Help/detail.vue'),
      meta: {
        footShow: true
      }
    },
    ...surveyRoutes,
    {
      path: '/down',
      name: 'down',
      component: () => import(/* webpackChunkName: "center" */ './views/Help/down.vue'),
      meta: {
        footShow: true
      }
    },
    {
      path: '/downdetail',
      name: 'downdetail',
      component: () => import(/* webpackChunkName: "center" */ './views/Help/downdetail.vue'),
      meta: {
        footShow: true
      }
    },
    {
      path: '/game',
      name: 'game',
      component: () => import(/* webpackChunkName: "center" */ './views/Game/index.vue'),
      meta: {
        title: '竞技赛事',
        l18ntitle: 'game',
        footShow: true,
        showAllNav:true
      }
    },
    {
      path: '/gamelist',
      name: 'gamelist',
      component: () => import(/* webpackChunkName: "center" */ './views/Game/list.vue'),
      meta: {
        title: '竞赛列表',
        footShow: true,
        showAllNav:false
      }
    },
    {
      path: '/gamedetail/:gameId',
      name: 'gamedetail',
      component: () => import(/* webpackChunkName: "product" */ './views/Game/Detail.vue'),
      meta: {
        title: '赛事详情',
        l18ntitle: 'detail',
        keepAlive: true
      }
    },
    {
      path: '/gameEntry/:gameId',
      name: 'gameEntry',
      component: () => import(/* webpackChunkName: "product" */ './views/Game/allEntry.vue'),
      meta: {
        title: '参赛人员',
        l18ntitle: 'detail',
        keepAlive: true
      }
    },
    {
      path: '/gameRanking/:gameId',
      name: 'gameRanking',
      component: () => import(/* webpackChunkName: "product" */ './views/Game/ranking.vue'),
      meta: {
        title: '排位赛',
        l18ntitle: 'detail',
        keepAlive: true
      }
    },
    {
      path: '/gameTie/:gameId',
      name: 'gameTie',
      component: () => import(/* webpackChunkName: "product" */ './views/Game/tie.vue'),
      meta: {
        title: '淘汰赛',
        l18ntitle: 'detail',
        keepAlive: true
      }
    },
    {
      path: '/gamePay/:order_id/:type/:title/:project_id/:bk',
      name: 'gamePay',
      component: () => import(/* webpackChunkName: "product" */ './views/Game/pay.vue'),
      meta: {
        title: '支付报名费',
        l18ntitle: 'detail'
      }
    },
    {
      path: '/exam',
      name: 'exam',
      component: () => import(/* webpackChunkName: "center" */ './views/Exam/index.vue'),
      meta: {
        title: '资质考试',
        l18ntitle: 'exam',
        footShow: true,
        showAllNav:true
      }
    },
    {
      path: '/examitem/:id',
      name: 'examitem',
      component: () => import(/* webpackChunkName: "center" */ './views/Exam/item.vue'),
      meta: {
        footShow: true
      } 
    },
    {
      path: '/enroll/:id',
      name: 'enroll',
      component: () => import(/* webpackChunkName: "center" */ './views/Exam/enroll.vue'),
      meta: {
        footShow: true
      }
    },
    {
      path: '/startExam/:order_id/:plan_id/:title',
      name:'startExam',
      component: () => import(/* webpackChunkName: "center" */ './views/Exam/startExam.vue'),
      meta: {
        footShow: true,
        // keepAlive: true
      }
    },
    {
      path: '/viewReport/:datas',
      name:'viewReport',
      component: () => import(/* webpackChunkName: "center" */ './views/Exam/viewReport.vue'),
      meta: {
        footShow: true
      }
    },
    {
      path: '/practice/:id/:title',
      name:'practice',
      component: () => import(/* webpackChunkName: "center" */ './views/Exam/practice.vue'),
      meta: {
        footShow: true
      }
    },
    {
      path: '/startChapterExercise/:id/:type_id/:title/:openTipCard',
      name:'startChapterExercise',
      component: () => import(/* webpackChunkName: "center" */ './views/Exam/startChapterExercise.vue'),
      meta: {
        footShow: true
      }
    },
    {
      path: '/myFaults/:id/:title',
      name:'myFaults',
      component: () => import(/* webpackChunkName: "center" */ './views/Exam/myFaults.vue'),
      meta: {
        footShow: true
      }
    },
    {
      path: '/myStart/:id/:title',
      name:'myStart',
      component: () => import(/* webpackChunkName: "center" */ './views/Exam/myStart.vue'),
      meta: {
        footShow: true
      }
    },
    {
      path: '/mySuccess/:id/:title',
      name:'mySuccess',
      component: () => import(/* webpackChunkName: "center" */ './views/Exam/mySuccess.vue'),
      meta: {
        footShow: true
      }
    },
    {
      path: '/startDescript/:c_id/:title/:paper_id/:model',
      name:'startDescript',
      component: () => import(/* webpackChunkName: "center" */ './views/Exam/startDescript.vue'),
      meta: {
        footShow: true
      }
    },
    {
      path: '/cashier/:order_id',
      name: 'cashier',
      component: () => import(/* webpackChunkName: "center" */ './views/Cashier.vue'),
      meta: {
        title: '收银台',
        l18ntitle: 'settlementList',
        headHide: true,
      },
    },
		{
		  path: '/group',
		  name: 'grouplist',
		  component: () => import(/* webpackChunkName: "center" */ './views/group/list.vue'),
		  meta: {
		    title: '团购列表',
		    l18ntitle: 'group',
				showAllNav: true,
		  },
		},
		{
		  path: '/group/detail/:id/:groupid',
		  name: 'groupdetail',
		  component: () => import(/* webpackChunkName: "center" */ './views/group/detail.vue'),
		  meta: {
		    title: '团购详情',
		    l18ntitle: 'group',
		  },
		},
		{
		  path: '/seckill',
		  name: 'seckilllist',
		  component: () => import(/* webpackChunkName: "center" */ './views/seckill/list.vue'),
		  meta: {
		    title: '秒杀列表',
		    l18ntitle: 'seckill',
				showAllNav: true,
		  },
		},
		{
		  path: '/seckill/detail/:id/:groupid',
		  name: 'seckilldetail',
		  component: () => import(/* webpackChunkName: "center" */ './views/seckill/detail.vue'),
		  meta: {
		    title: '秒杀详情',
		    l18ntitle: 'seckill',
		  },
		},
    {
		  path: '/lottery',
		  name: 'lottery',
		  component: () => import(/* webpackChunkName: "center" */ './views/lottery.vue'),
		  meta: {
		    title: '抽奖页面',
		    l18ntitle: 'seckill',
        keepAlive: false
		  },
		},
    {
      path: "*",
      redirect: "/"
    }
  ],
  scrollBehavior(to, from, savedPosition) {

    // if (savedPosition && to.meta.keepAlive) {
    //   return savedPosition
    // } else {
      return { x: 0, y: 0 }
    // }

  }
})

